import type { AwardProps } from '@modules/page-builder/component/detail/banner-awards/types';

export interface AwardsRowContentProps {
    awards: AwardProps[];
}

/**
 * Awards accordion row — the year / institution / title lines from the legacy
 * `AwardAccordion`, restyled for the revamp's numbered accordion (which
 * supplies the expand/collapse).
 */
export const AwardsRowContent = ({ awards }: AwardsRowContentProps) => (
    <div className="pb-[1.8rem] max-md:pb-4">
        {awards.map((award) => (
            <div
                key={award.id}
                className="grid border-b border-black/10 py-[0.75rem] last:border-0 max-md:grid-cols-1 max-md:gap-1 md:grid-cols-[6rem_18rem_1fr] md:gap-4"
            >
                <span className="font-sans text-[0.8124rem] leading-snug font-normal text-[#767676]">
                    {award.year}
                </span>
                <span className="font-sans leading-[1.3] font-normal text-[#1f1f21] max-md:text-sm md:text-[1.375rem]">
                    {award.institution}
                </span>
                <span className="font-sans leading-[1.3] font-normal text-[#1f1f21] max-md:text-sm md:text-[1.375rem]">
                    {award.title}
                </span>
            </div>
        ))}
    </div>
);
